import {frontend} from 'pageflow-scrolled/frontend';

import {InfoGrid} from './InfoGrid';

frontend.contentElementTypes.register('infoGrid', {
  component: InfoGrid
});
